import serviceBase from "./serviceBase";
import { EndPoint } from "../appConfig";

var CheckinService = Object.create(new serviceBase(EndPoint.Checkin));
CheckinService.getCheckinsById = function(meetingId) {
  return this.get({
    meeting_id: meetingId
  });
};
CheckinService.doCheckin = function(meetingId, roomId, roomTag, success) {
  return this.post({
    event: {
      ical_uid: meetingId
    },
    room_id: roomId,
    room_tag: roomTag,
    is_pc: 1
  }).then(success);
};
export default CheckinService;
